export default {"src":"/_next/static/media/3dot.80257466.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};